import { resolve } from '@/legacy/lib//util';

const languages = {
  global: {
    true: 'Yes',
    false: 'No',
    null: '',

    speed: {
      0: 'Slow',
      1: 'Normal',
      2: 'Fast'
    },

    visibility: {
      0: 'Hidden',
      1: 'Explored',
      2: 'Always Visible',
      3: 'Default'
    },

    observers: {
      0: 'None',
      2: 'On Defeat',
      3: 'Full',
      4: 'Referee'
    },

    colour: {
      0: 'red',
      1: 'blue',
      2: 'teal',
      3: 'purple',
      4: 'yellow',
      5: 'orange',
      6: 'green',
      7: 'pink',
      8: 'grey',
      9: 'light-blue',
      10: 'dark-green',
      11: 'brown',
      12: 'maroon',
      13: 'navy',
      14: 'turquoise',
      15: 'violet',
      16: 'wheat',
      17: 'peach',
      18: 'mint',
      19: 'lavender',
      20: 'coal',
      21: 'snow',
      22: 'emerald',
      23: 'peanut'
    },

    channel: {
      0: 'All',
      1: 'Allies',
      2: 'Observer',
      3: 'Private'
    }
  }
};

/** **/

export function lang (key, language)
{
  if (!language) {
    language = languages.global;
  }

  if (key in language) {
    return language [key];
  }

  return resolve (key, language);
}